(() => {
  if (window.__jardexLipscoreWidgets) return;
  window.__jardexLipscoreWidgets = true;
  let scheduled = false;
  const initialize = () => {
    scheduled = false;
    if (typeof window.lipscore?.initWidgets === 'function') window.lipscore.initWidgets();
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(initialize);
  };
  // The app initializer owns first load. Only initialize newly rendered widgets,
  // for example after Shopify sections or the product variant fragment changes.
  document.addEventListener('shopify:section:load', schedule);
  // Lipscore har to uoversatte engelske tekster i anmeldelseslisten: en tooltip paa fordelingsraekkerne
  // ("View reviews with  star(s)", raekkens egen tekst er dansk, saa title fjernes) og knappen
  // "Reset filter" (faar teksten fra data-jardex-reset-label, en oversaettelsesnoegle i snippet'en).
  // Ingen af delene tilfoejer elementer, saa observeren nedenfor udloeses ikke igen. 4. okt 2026
  const ROW = '.lipscore-rating-distribution-row[title]';
  const RESET = '.lipscore-rating-distribution-reset-btn';
  const fixLipscoreText = n => {
    for (const el of [n, ...n.querySelectorAll(`${ROW}, ${RESET}`)]) {
      if (el.matches(ROW)) el.removeAttribute('title');
      if (el.matches(RESET)) {
        // The review modal opened from the badge lives under <body>, so fall back to any label on the page. Mobil-QA 5. okt 2026
        const label = (el.closest('[data-jardex-reset-label]') || document.querySelector('[data-jardex-reset-label]'))?.dataset.jardexResetLabel;
        if (label && el.textContent !== label) el.textContent = label;
      }
    }
  };
  const observe = () => {
    fixLipscoreText(document.body);
    new MutationObserver((mutations) => {
      let added = false;
      for (const m of mutations) for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        fixLipscoreText(n);
        if (n.matches('[data-jardex-lipscore]') || n.querySelector('[data-jardex-lipscore]')) added = true;
      }
      if (added) schedule();
    }).observe(document.body, {childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, {once:true});
  else observe();
})();
